import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  updatePassword,
} from '@firebase/auth'
import { doc, setDoc, getDoc, updateDoc, collection, serverTimestamp } from '@firebase/firestore'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { showLoader } from 'src/utils/loader'
import { auth, db } from 'src/firebase/config'
import { authAction } from 'src/features/auth/authSlice'
import moment from "moment"

const staffRef = 'staff'

const useAuth = () => {
  const dispatch = useDispatch()

  const autoLogin = () => {
    const unsubscribe = onAuthStateChanged(
      auth,
      async (currentUser) => {
        if (currentUser) {
          let user = currentUser
          const profile = await getDoc(doc(collection(db, staffRef), user.uid)).then((doc) =>
            doc.data(),
          )
          window.currentUser = currentUser
          if (!profile) {
            showLoader(false)
            auth.signOut()
            toast.error('You are not Staff Member')
            return
          }

          dispatch(
            authAction.login({
              uid: user.uid,
              profile: user.providerData[0],
              user: {
                ...profile,
                uid: user.id,
                createdAt: profile?.createdAt && moment(profile?.createdAt?.toDate()).format(),
                updatedAt: profile?.updatedAt && moment(profile?.updatedAt?.toDate()).format(),
              },
              roles: [profile.role],
              status: 'idle',
            }),
          )

          // currentUser
          //   .getIdTokenResult()
          //   .then((idTokenResult) => {
          //     showLoader(false)
          //     dispatch(
          //       authAction.claimsAction({
          //         claims: idTokenResult.claims,
          //       }),
          //     )
          //     // setClaims(idTokenResult.claims)
          //     // console.log("claims", idTokenResult.claims)
          //     // // Confirm the user is an Admin.
          //     // if (!!idTokenResult.claims.admin) {
          //     //   console.log("admin")
          //     //   // Show admin UI.
          //     //   // showAdminUI()
          //     // } else {
          //     //   // Show regular user UI.
          //     //   // showRegularUI()
          //     // }
          //   })
          //   .catch((error) => {
          //     showLoader(false)
          //     console.log(error)
          //   })
        } else {
          dispatch(
            authAction.authError({
              status: 'idle',
            }),
          )
          showLoader(false)
        }
      },
      (error) => {
        dispatch(
          authAction.authError({
            status: 'idle',
          }),
        )
        console.log(error)
        showLoader(false)
      },
    )
    return unsubscribe
  }

  /**
   *
   * @param {*} email
   * @param {*} password
   * @returns
   */
  const signup = (email, password, profile) => {
    showLoader(true)
    let tid = toast.loading('Registering...')
    return new Promise((resolve, reject) =>
      createUserWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
          // Signed in
          const user = userCredential.user
          // console.log(user)

          profile.createdAt = serverTimestamp()
          setDoc(doc(collection(db, staffRef), user.uid), profile)

          // updateProfile(user, {
          //   displayName: profile.displayName,
          //   phoneNumber: profile.mobile,
          //   // photoURL: "",
          //   // claims: {
          //   //   "admin": true,
          //   //   "staff": true
          //   // }
          //   // photoURL: "https://example.com/jane-q-user/profile.jpg"
          // })
          // const collection(db, usersRef) = collection(db, "users")
          // const userData = await getDoc(doc(collection(db, usersRef), user.uid)).then(doc => doc.data())

          dispatch({
            type: 'TOKEN_LOGIN',
            uid: user.uid,
            // displayName: user.providerData[0]?.displayName || "User",
            // profile: user.providerData[0],
            staff: {
              ...profile,
              uid: user.id,
              createdAt: profile?.createdAt && moment(profile?.createdAt?.toDate()).format(),
              updatedAt: profile?.updatedAt && moment(profile?.updatedAt?.toDate()).format(),
            },
            // cars: [],
            // profile: userData,
            // cars: userData?.cars,
            // profile: user,
            status: 'idle',
          })
          toast.update(tid, {
            render: 'Registered successfully.',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          return resolve(user)
          // return user
        })
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          if (errorCode === 'auth/email-already-in-use') {
            errorMessage = 'This email is already registered. Please try to login with it.'
          }
          if (errorCode === 'auth/wrong-password') {
            errorMessage = 'Wrong password.'
          }
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
          reject(error)
        })
        .finally(() => {
          showLoader(false)
        }),
    )
  }

  /**
   *
   * @param {*} email
   * @param {*} password
   * @returns Promise<user>
   */
  const login = (email, password) =>
    new Promise((resolve) => {
      showLoader(true)
      const tid = toast.loading('Authenticating...')
      signInWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
          // Signed in
          const user = userCredential.user
          // let carDetails = []
          const profile = await getDoc(doc(collection(db, staffRef), user.uid)).then((doc) =>
            doc.data(),
          )
          if (!profile) {
            showLoader(false)
            auth.signOut()
            toast.error('You are not Staff Member')
            return
          }

          dispatch(
            authAction.login({
              uid: user.uid,
              profile: user.providerData[0],
              user: {
                ...profile,
                uid: user.id,
                createdAt: profile?.createdAt && moment(profile?.createdAt?.toDate()).format(),
                updatedAt: profile?.updatedAt && moment(profile?.updatedAt?.toDate()).format(),
              },
              roles: [profile.role],
              status: 'idle',
            }),
          )

          // showLoader(false)
          toast.update(tid, {
            render: 'Logged in successfully.',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          return resolve(profile)
          // return user
        })
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          if (errorCode === 'auth/wrong-password') {
            errorMessage = 'Wrong password.'
          }
          if (errorCode === 'auth/user-disabled') {
            errorMessage = 'Your account is blocked.'
          }
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
        })
        .finally(() => {
          showLoader(false)
        })
    })

  const logout = () =>
    new Promise((resolve) => {
      showLoader(true)
      let tid = toast.loading('Requesting...')
      signOut(auth)
        .then(() => {
          dispatch(authAction.logout())
          toast.update(tid, {
            render: 'Logged out successfully.',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          return resolve()
        })
        .catch((error) => {
          var errorMessage = error.message
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
        })
        .finally(() => {
          showLoader(false)
        })
    })

  const forgotPassword = (email) =>
    new Promise((resolve) => {
      showLoader(true)
      const tid = toast.loading('Requesting...')
      sendPasswordResetEmail(auth, email)
        .then(() => {
          // Password Reset Email Sent!
          toast.update(tid, {
            render: 'Password Reset Email Sent!',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          return resolve()
        })
        .catch((error) => {
          // Handle Errors here.
          var errorCode = error.code
          var errorMessage = error.message
          if (errorCode === 'auth/invalid-email') {
            errorMessage = 'Email is not valid.'
          } else if (errorCode === 'auth/user-not-found') {
            errorMessage = 'User not found with this email.'
          }
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
          console.log(error)
        })
        .finally(() => {
          showLoader(false)
        })
    })

  // function changeEmail(email) {
  //   return updateEmail(user, email)
  // }

  // function changePassword(password) {
  //   return updatePassword(user, password)
  // }

  const updateAuthPassword = (newPassword) =>
    new Promise((resolve) => {
      const tid = toast.loading('Updating...')

      const user = auth.currentUser
      showLoader(true)
      updatePassword(user, newPassword)
        .then(() => {
          toast.update(tid, {
            render: 'Password Updated successfully.',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          return resolve()
        })
        .catch((error) => {
          var errorMessage = error.message
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
        })
        .finally(() => {
          showLoader(false)
        })
    })

  const updateAuthProfile = (profile) => {
    updateProfile(auth.currentUser, profile)
      .then(() => {
        console.log('Updated')
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const updateUserProfile = (uid, payload) =>
    new Promise((resolve) => {
      const tid = toast.loading('Updating...')
      showLoader(true)
      updateDoc(doc(db, staffRef, uid), payload)
        .then(() => {
          toast.update(tid, {
            render: 'Updated successfully.',
            type: 'success',
            isLoading: false,
            autoClose: true,
          })
          dispatch(
            authAction.updateProfile({
              updated: payload,
              status: 'idle',
            }),
          )
          return resolve()
        })
        .catch((error) => {
          var errorMessage = error.message
          toast.update(tid, {
            render: errorMessage,
            type: 'error',
            isLoading: false,
            autoClose: true,
          })
        })
        .finally(() => {
          showLoader(false)
        })
    })

  return {
    signup,
    autoLogin,
    login,
    logout,
    forgotPassword,
    updateAuthProfile,
    updateAuthPassword,
    updateUserProfile,
  }
}

export { useAuth }
